/**
 * DR-1 — the pages a client or an outsider opens. One list, one place: the
 * assistant, the floating rail and the global dark toggle are the staff app's
 * furniture and are not rendered on any of them. The Consultation counts: it
 * is the client's own page.
 */
export const CLIENT_ROUTES = ['/drawing-room/', '/site-office/', '/s/', '/r/',
  '/portfolio/', '/consultation/'];

/**
 * DR-2d — where Android's share sheet lands, and the key the Drawing Room
 * remembers its own link under so the share page knows whose wall to add to.
 * The page sits under '/drawing-room/', so CLIENT_ROUTES already covers it.
 */
export const DREAM_SHARE_ROUTE = '/drawing-room/share';
export const PORTAL_TOKEN_KEY = 'km_portal_token';

/**
 * PW-1 — every page an outsider can open without signing in: the client's own
 * pages above, plus a scanned tag, a phone widget and a popped-out panel. The
 * staff app's install card is not offered on any of them.
 */
export const PUBLIC_ROUTES = [...CLIENT_ROUTES, '/m/', '/widget/', '/popout/'];

export function isClientRoute(pathname) {
  if (!pathname) return false;
  const path = pathname.endsWith('/') ? pathname : `${pathname}/`;
  return CLIENT_ROUTES.some((r) => path.startsWith(r))
    || /^\/projects\/[^/]+\/site-office\//.test(pathname);
}

export default isClientRoute;
